<!-- Language Selection Popup -->
<div class="popup" *ngIf="showLanguagePopup">
  <div class="popup-content">
    <mat-icon class="close" (click)="closePopup()">close</mat-icon>
    <img [src]="'https://cube.getpitstop.com/prodimages/learn-with-autoverse/eng_backend1.jpeg'" alt="Popup Image" />

    <button
      (click)="chooseLanguage('english')" 
      [ngClass]="{ 'selected-btn': selectedLanguage === 'english' }">
      English
    </button>

    <button 
      (click)="chooseLanguage('kannada')" 
      [ngClass]="{ 'selected-btn': selectedLanguage === 'kannada' }">
      ಕನ್ನಡ
    </button>
  </div>

  <img [src]="backgroundImage?.trim()" alt="Popup Image" *ngIf="backgroundImage" />
</div>


<!-- Main Content -->
<div *ngIf="!showLanguagePopup" class="learn-wth-autoverse-main">
  <div class="title">
    <img src="../../../../assets/images/learn-with-autoverse-background-image.jpg" class="title-img">
  </div>


  <div class="main-content-from-search">
    <div class="search-bar">
      <mat-icon>search</mat-icon>
      <input   class="search-input" type="text" [formControl]="searchControl" placeholder="Search tutorials" />
      <button *ngIf="searchControl.value" class="clear-button" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="tabs">
      <span *ngFor="let tab of tabs" [class.active]="tab === selectedTab" (click)="selectTab(tab)">
        {{ tab }}
      </span>
    </div>

    <div  class = "video-card-main">
        <div class="video-card" *ngFor="let video of dummyVideos" (click)="openVideoPopup(video)">
          <img [src]="video.videoThumbNails?.trim() || 'assets/default-thumb.png'" alt="Video thumbnail" />
          <h4>{{ video.videoTitles }}</h4>
        </div>

    </div>

    <!-- No Videos image -->
    <div class="no-img" *ngIf="!loading && dummyVideos.length === 0">
      <img [src]="emptyList" alt="No videos available" />
      <h1 class="no-request-text">No Videos Found</h1>
      <div class="edit-text">Try editing the search or change category</div>
    </div>

  </div>
</div>

<!-- Video Popup Modal -->
<div class="video-popup" *ngIf="activeVideoUrl">
  <div class="video-popup-content" #videoContainer>
    <mat-icon class="close" (click)="closeVideoPopup()">close</mat-icon>
    <iframe
      width="560"
      height="315"
      [src]="activeVideoUrl"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen>
    </iframe>
  </div>
</div>
